import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Trophy } from "lucide-react";
export default function IgniteYourGrowth() {
  return <section data-section-id="240228" id="ignite-your-growth" className="relative bg-background text-foreground flex items-center justify-center min-h-[70vh] overflow-hidden ![padding:30px_16px_30px_16px]">
      {}
      <div className="absolute inset-0 bg-gradient-to-br from-secondary via-chart-3 to-primary opacity-90" />
      
      {}
      <div className="absolute inset-0 bg-background/40 backdrop-blur-[2px]" />

      {}
      <div className="relative z-10 flex flex-col items-center text-center max-w-4xl mx-auto gap-10">
        <h2 className="text-5xl md:text-7xl font-bold font-default tracking-tighter text-foreground uppercase drop-shadow-2xl">
          Ready to Grow Your Business?
        </h2>

        <div className="flex flex-col items-center gap-8 mt-4">
          {}
          <div className="relative group">
            {}
            <div className="absolute -inset-2 bg-secondary rounded-lg blur-xl opacity-30 animate-pulse transition duration-1000 group-hover:opacity-60 group-hover:duration-200" />
            
            <Link to="/ContactPage">
              <Button size="lg" className="relative text-lg md:text-xl px-12 py-8 rounded-lg font-bold font-default tracking-wide uppercase shadow-2xl bg-foreground text-background hover:bg-foreground/90 transition-all duration-300">
                <Trophy className="mr-3 size-6 text-primary" />
                Get Your Free Quote
              </Button>
            </Link>
          </div>

          {}
          <Link to="/AboutUsPage" className="text-sm md:text-base text-foreground/80 hover:text-primary transition-colors underline underline-offset-4 font-default font-medium">
            Websites That Work While You Sleep
          </Link>
        </div>
      </div>
    </section>;
}